// src/App.js
import { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ManajemenSiswa from './components/ManajemenSiswa';
import CatatKehadiran from './components/CatatKehadiran';
import LaporanKehadiran from './components/LaporanKehadiran';
import JurnalPembelajaran from './components/JurnalPembelajaran';
import BackupData from './components/BackupData';

export default function App() {
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('dashboard');

  // supaya tetap login walau halaman di-refresh
  useEffect(() => {
    const saved = sessionStorage.getItem('user');
    if (saved) setUser(JSON.parse(saved));
  }, []);

  function handleLogout() {
    sessionStorage.removeItem('user');
    setUser(null);
    setPage('dashboard');
  }

  if (!user) {
    return <Login onLoginSuccess={setUser} />;
  }

  if (page === 'siswa') {
    return <ManajemenSiswa onBack={() => setPage('dashboard')} />;
  }

  if (page === 'kehadiran') {
    return <CatatKehadiran onBack={() => setPage('dashboard')} />;
  }

  if (page === 'laporan') {
    return <LaporanKehadiran onBack={() => setPage('dashboard')} />;
  }

  if (page === 'jurnal') {
    return <JurnalPembelajaran user={user} onBack={() => setPage('dashboard')} />;
  }

  if (page === 'backup') {
    return <BackupData onBack={() => setPage('dashboard')} />;
  }

  if (page === 'dashboard') {
    return <Dashboard user={user} onNavigate={setPage} onLogout={handleLogout} />;
  }

  // Halaman Manajemen Pengguna akan menggantikan placeholder ini berikutnya.
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <p className="text-lg text-gray-800 mb-4">Halaman "{page}" belum dibuat.</p>
        <button onClick={() => setPage('dashboard')} className="text-blue-600 underline">
          Kembali ke Dashboard
        </button>
      </div>
    </div>
  );
}
